<script setup lang="ts">
import { onMounted, ref } from 'vue'

const polyLang = ref([])
const polyLangCurrent = ref(false)

onMounted(async () => {
    // pll translations: list and current language mockup -->
    if (typeof window.pllLanguages !== 'undefined' && Object.keys(window.pllLanguages).length > 0) {
        Object.keys(window.pllLanguages).forEach((key) => {
            polyLang.value.push(window.pllLanguages[key])
            if (window.pllLanguages[key].current_lang === true) {
                polyLangCurrent.value = window.pllLanguages[key]
            }
        })
    }
    // <-- pll translations: list and current language
})
</script>
<template>
    <!-- start polylang -->
    <div v-if="polyLang.length > 0" class="d-flex align-items-center select-language dropdown dropdown-select ml-4">
        <div class="dropdown-title text-gray d-flex align-items-center lang-dropdown">
            <img :src="polyLangCurrent.flag" :alt="polyLangCurrent.name" class="flag mr-2" />
            <span class="d-none-md text-uppercase">{{ polyLangCurrent.slug }}</span>
        </div>
        <ul class="dropdown-list ml-0 list-none bg-white">
            <li class="text-gray-dark bold select-item d-flex align-items-center justify-between p-2">
                {{ $t('language_switcher_select_language') }}
            </li>
            <li
                v-for="translation in polyLang"
                :key="translation.id"
                :class="`${translation.slug !== polyLangCurrent.slug ? 'text-gray' : ''} select-item p-2`">
                <a
                    :class="`${
                        translation.slug !== polyLangCurrent.slug ? 'text-gray' : 'text-secondary'
                    } w100 d-flex align-items-center`"
                    :href="translation.url">
                    <img class="flag mr-2" :src="translation.flag" :alt="translation.slug" /> {{ translation.name }}
                    <span class="text-uppercase-sm mx-2">({{ translation.slug }})</span>
                    <i
                        v-if="translation.slug === polyLangCurrent.slug"
                        class="fa fa-check-circle"
                        aria-hidden="true"
                        style="width: 25px"></i>
                </a>
            </li>
        </ul>
    </div>
    <!-- end polylang -->
</template>

<style scoped></style>
